import { fromJS } from 'immutable';
import { DROPOFF_COLOR } from './colors';
export const NODE_WIDTH = 25;
export const getDropoffByNode = layout => layout.columns.reduce((acc, column) => {
  return Object.assign({}, acc, column.nodes.reduce((columnAcc, node) => Object.assign({}, columnAcc, {
    [node.id]: node.dropoff
  }), {}));
}, {});
const generateScalingFunction = data => {
  const max = Math.max(...data);
  const floor = max / 10;
  const scalingCoefficient = 10 / max;
  return input => scalingCoefficient * (input < floor ? floor : input);
};
const generateScaledData = (data, {
  destinationNodeTotal,
  linkMeasure
}) => {
  const unscaledData = data.map(row => ({
    nodeWeight: row[destinationNodeTotal],
    linkWeight: row[linkMeasure]
  }));
  const scalingFunction = generateScalingFunction(unscaledData.map(datum => datum.nodeWeight));
  return unscaledData.reduce((accum, {
    linkWeight,
    nodeWeight
  }) => linkWeight === 0 ? accum : Object.assign({}, accum, {
    [linkWeight]: scalingFunction(nodeWeight) * (linkWeight / nodeWeight)
  }), {
    0: 0
  });
};
const generateOnClickFunction = onPointClick => event => {
  // weight from event.point is scaled, not raw - do not use
  const {
    from,
    id,
    isNode,
    to
  } = event.point;
  const point = {
    row: {}
  };
  if (isNode) {
    point.row.to = id;
  } else {
    point.row.from = from;
    point.row.to = to;
  }
  onPointClick({
    point: fromJS(point)
  });
};
const getSeriesDataWithoutZeroDropoffNodes = (seriesData, dropoffByNode, highchartNodes) => {
  const zeroDropoffIds = highchartNodes.filter(node => dropoffByNode[node.id] && node.name === '0').map(node => node.id);
  return seriesData.filter(node => !zeroDropoffIds.includes(node.to));
};
export const getSeriesOptions = (dataset, highchartNodes, layout, onPointClick, scaleEnabled, removeZeroDropoffNodes) => {
  const dropoffByNode = getDropoffByNode(layout);
  const weightMappings = scaleEnabled && generateScaledData(dataset.data, layout.measures);
  const seriesData = dataset.data.map(dataNode => {
    const to = dataNode[layout.destinationField];
    return Object.assign({
      from: dataNode[layout.originField],
      to,
      weight: weightMappings ? weightMappings[dataNode[layout.measures.linkMeasure]] : dataNode[layout.measures.linkMeasure]
    }, dropoffByNode[to] ? {
      outgoing: true,
      color: DROPOFF_COLOR
    } : {});
  });
  const onClick = onPointClick ? generateOnClickFunction(onPointClick) : undefined;
  return fromJS([{
    type: 'sankey',
    data: removeZeroDropoffNodes ? getSeriesDataWithoutZeroDropoffNodes(seriesData, dropoffByNode, highchartNodes) : seriesData,
    nodes: highchartNodes,
    events: {
      click: onClick
    },
    nodeWidth: NODE_WIDTH,
    dataLabels: {
      enabled: true
    }
  }]);
};
export const __TESTABLE__ = {
  generateOnClickFunction,
  generateScalingFunction
};